var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKarmaPoint = function SvgKarmaPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.89 6.772a7.3 7.3 0 0 0 4.338 4.338l1.546.567c.301.11.301.536 0 .646l-1.495.548a7.41 7.41 0 0 0-4.408 4.408l-.548 1.495c-.11.301-.536.301-.646 0l-.548-1.495a7.41 7.41 0 0 0-4.408-4.408l-1.495-.548a.344.344 0 0 1 0-.646l1.495-.548a7.41 7.41 0 0 0 4.408-4.408l.548-1.495a.344.344 0 0 1 .646 0z"
  })));
};
export { SvgKarmaPoint as ReactComponent };